module.exports = __webpack_public_path__ + "static/media/hc-ecosystem.b569e578.svg";